<template>
  <div id="body-fat-index">
    Max weight
    <form @submit.prevent="calculate">
      <div>
        <input type="number" min="0" v-model="weight" placeholder="Pressed weight (kg)" />
      </div>
      <div>
        <input type="number" min="0" v-model="reps" placeholder="Reps" />
      </div>
      <input type="submit" value="Send" />
    </form>
    <div v-if="displayFields">
      <div class="maximum-weight">
        The one-rep max indicator is:
        <div>{{this.result.toFixed(0)}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MaximumWeightEn",
  methods: {
    calculate: function () {
      this.result = Math.round(this.weight * (1 + this.reps / 30));
      this.displayFields = true;
    },
  },
  data() {
    return {
      weight: null,
      reps: null,
      result: 0,
      displayFields: false,
    };
  },
};
</script>

